import axios from "axios";

export function authHeader() {
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    // return authorization header with jwt token
    let token = localStorage.getItem('token');
    if (token) {
        axios.defaults.headers.common = {
            "Authorization": 'Bearer ' + token
        };
    } else {
        return {};
    }
}
